import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetPayments = () => {
  return useQuery({
    queryKey: ["payments"],
    queryFn: async () => {
      try {
        const response = await axios.get("/api/payment");
        console.log("API Response:", response.data);
        return response.data;
      } catch (error) {
        console.error("API Error:", error);
        throw error;
      }
    },
    staleTime: 30000, // Optional
  });
};

export default useGetPayments;
